export const SCOPE_SMART_ADVISOR = 'SmartAdvisor';
export const SCOPE_FARM_PROFILE = 'FarmProfile';
